<template>
  <div class="contact">
    <inner-page-banner-component></inner-page-banner-component>

    <div class="contact-form">
      <h4 class="form-title">Have a question? We'd love to hear from you</h4>
      <h5 class="form-subtitle">Drop us a message using the form below.</h5>

      <form @submit.prevent="onSubmit" method="post" action="#" role="form">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="inputName" class="control-label">Name</label>
              <input
                type="text"
                name="name"
                v-model="form.name"
                value=""
                class="form-control"
                id="inputName"
                required
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="inputEmail" class="control-label"
                >Email Address</label
              >
              <input
                type="email"
                name="email"
                v-model="form.email"
                value=""
                class="form-control"
                id="inputEmail"
                required
              />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label for="inputSubject" class="control-label">Subject</label>
              <input
                type="subject"
                v-model="form.subject"
                name="subject"
                value=""
                class="form-control"
                id="inputSubject"
                required
              />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label for="inputMessage" class="control-label">Message</label>
              <textarea
                name="message"
                rows="7"
                class="form-control"
                v-model="form.message"
                id="inputMessage"
              ></textarea>
            </div>
          </div>

          <input type="hidden" name="_subject" value="Contact form submitted" />

          <div class="col-sm-12">
            <div class="form-group">
              <vue-recaptcha
                :key="captchaKey"
                @verify="recaptchaVerified()"
                sitekey="6Ld7wMcbAAAAALS68M5Q2jy5GWoMBbkZei2itscx"
                :loadRecaptchaScript="true"
              ></vue-recaptcha>
            </div>
          </div>
        </div>
        <div class="form-actions flex-center">
          <button type="submit" class="btn btn-primary">Send Message</button>
        </div>
      </form>
    </div>
    <div class="clearfix ptb20"></div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";

const DefaultForm = {
  _subject: "Contact form submitted",
};

export default {
  name: "ContactComponent",
  components: { VueRecaptcha },
  methods: {
    onSubmit: function (e) {
      if (!this.verified) {
        this.$toast.error("Please verify captcha before submitting form", {
          duration: 3000,
        });

        return;
      }


      fetch("https://submit-form.com/xsVcJYfm", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        }, 
        body: JSON.stringify(this.form),
      })
        .then(() => {
          this.form = Object.assign({}, DefaultForm);

          this.$toast.success(
            "Your message is on its way! We'll get back to you as soon as possible",
            { duration: 3000 }
          );
        })
        .catch(() => {
          this.$toast.error(
            "There was an error sending your message. Please try again later",
            { duration: 3000 }
          );
        })
        .finally(() => {
          this.verified = false;
          this.captchaKey = Math.random();
        });
    },
    recaptchaVerified: function () {
      this.verified = true;
    },
  },
  data: function () {
    return {
      verified: false,
      captchaKey: 0,
      form: Object.assign({}, DefaultForm),
    };
  },
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "Have a question? Our FAQs page may give you your answer. If not we're available 24/7 via Live Chat or you can fill in our contact form - we'll be in touch ASAP.",
      },
    ],
  },
};
</script>

<style scoped lang="scss">
.contact-form {
  padding: 0 20px;
  max-width: 1000px;
  margin: 50px auto;

  h4,
  h5,
  h6 {
    text-align: center;
    font-weight: bold;
  }

  form {
    margin-top: 50px;
  }

  input,
  textarea,
  button {
    border-radius: 0;
  }

  .btn {
    background: #0e324d;
    border-color: #0e324d;
  }
}
</style>